import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class MailboxRulesService {
  env = environment.env;
  mailBoxRulesURL = endpointsURL.mailBoxRulesURL;

  constructor(private httpClient: HttpClient) {}

  public getCertificatesByAnalyst(idAnalyst: string): Observable<any[]> {
    let params = new HttpParams().set("analista", idAnalyst);

    return this.httpClient.get<any[]>(
      `${this.env}${this.mailBoxRulesURL}/certificados`,
      {
        params: params,
      }
    );
  }

  public getBrandsByAnalyst(idAnalyst: string): Observable<any[]> {
    let params = new HttpParams().set("analista", idAnalyst);

    return this.httpClient.get<any[]>(
      `${this.env}${this.mailBoxRulesURL}/marcas`,
      {
        params: params,
      }
    );
  }

  public saveMailBoxRule(
    arraysToSave: any,
    idAnalyst: string
  ): Observable<any> {
    const body = {
      analista: idAnalyst,
      certificados: arraysToSave.arrayCertificates,
      marcas: arraysToSave.arrayBrands,
    };

    return this.httpClient.put<any>(`${this.env}${this.mailBoxRulesURL}`, body);
  }
}
